import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-detail-history-users',
  templateUrl: './detail-history-users.component.html',
  styleUrls: ['./detail-history-users.component.scss'],
})
export class DetailHistoryUsersComponent implements OnInit {
  @Input() item: any = undefined;
  @Output() emitClosed = new EventEmitter();
  constructor() { }

  ngOnInit() {}
  close() {
    this.item = undefined
    this.emitClosed.emit();
  }
  onOrder(id) {
    window.open(`/admin/paylist?order=${id}`)
  }
}
